import React, { createContext, useCallback, useContext, useEffect, useState } from "react";

const ChatContext = createContext(null);
const SESSION_KEY = "leovera_chat_session_v103";

export const ChatProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [sessionId, setSessionId] = useState(() => {
    try { return localStorage.getItem(SESSION_KEY) || null; } catch { return null; }
  });
  const [prefillMessage, setPrefillMessage] = useState("");

  useEffect(() => {
    if (sessionId) {
      try { localStorage.setItem(SESSION_KEY, sessionId); } catch { /* ignore */ }
    }
  }, [sessionId]);

  const openWith = useCallback((message = "") => {
    if (message) setPrefillMessage(message);
    setOpen(true);
  }, []);

  const consumePrefill = useCallback(() => {
    const m = prefillMessage;
    setPrefillMessage("");
    return m;
  }, [prefillMessage]);

  const resetSession = useCallback(() => {
    setSessionId(null);
    try { localStorage.removeItem(SESSION_KEY); } catch { /* ignore */ }
  }, []);

  return (
    <ChatContext.Provider value={{
      open, setOpen, openWith, consumePrefill,
      sessionId, setSessionId, resetSession,
    }}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChat = () => {
  const ctx = useContext(ChatContext);
  if (!ctx) throw new Error("useChat must be used inside ChatProvider");
  return ctx;
};
